import React from "react"

function HomeHero() {
  return (
    <div className="home-hero">
      <h1 className="hero-title">A flavour for all seasons</h1>
    </div>
  );
}

export default HomeHero
